import MagnifyingGlassIcon from '@/components/icons/magnifying-glass'
import { FormControl, FormField, FormItem } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export default function FormSearchInput({
  control,
  showLabel,
  placeholder = 'Search',
}) {
  return (
    <FormField
      control={control}
      name="search"
      render={({ field }) => (
        <FormItem>
          {showLabel && <Label>Search</Label>}

          <FormControl>
            <div className="relative flex items-center md:max-w-[300px]">
              <Input
                className="pl-10"
                type="search"
                placeholder={placeholder}
                {...field}
              />
              <MagnifyingGlassIcon className="pointer-events-none absolute ml-4 h-4 w-4 stroke-shades-0 stroke-2" />
            </div>
          </FormControl>
        </FormItem>
      )}
    />
  )
}
